import api from './api';
import { StaticPage, StaticPageFormData, ApiResponse } from '../../types/staticPage.types';

export const staticPagesService = {
  getAll: async (): Promise<ApiResponse<StaticPage[]>> => {
    const response = await api.get<ApiResponse<StaticPage[]>>('/api/static-pages');
    return response.data;
  },

  getById: async (id: number): Promise<ApiResponse<StaticPage>> => {
    const response = await api.get<ApiResponse<StaticPage>>(`/api/static-pages/${id}`);
    return response.data;
  },

  create: async (data: StaticPageFormData): Promise<ApiResponse<StaticPage>> => {
    const response = await api.post<ApiResponse<StaticPage>>('/api/static-pages', data);
    return response.data;
  },

  update: async (id: number, data: StaticPageFormData): Promise<ApiResponse<StaticPage>> => {
    const response = await api.put<ApiResponse<StaticPage>>(`/api/static-pages/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<ApiResponse<void>> => {
    const response = await api.delete<ApiResponse<void>>(`/api/static-pages/${id}`);
    return response.data;
  },
};
